import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { PAGE_HEADER_THEME } from '@packages/layout/lib/PageHeader/theme';
import { createMemo } from '@packages/react';
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { Context } from '../UIShell/context';

interface SidebarToggleProps {
    color?: string;
}

export const SidebarToggle = createMemo<SidebarToggleProps>(
    ({ color }) => {
        const [, { toggleDrawer }] = useContext(Context);

        const handleClick = useCallback(() => toggleDrawer(), [toggleDrawer]);

        return (
            <Button $color={color} onClick={handleClick}>
                <Icon>menu</Icon>
            </Button>
        );
    },
    {
        displayName: 'SidebarToggle',
    },
);

const Button = styled(IconButton)<{ $color?: string }>`
    &,
    .MuiIcon-root {
        color: ${({ $color }) => $color || PAGE_HEADER_THEME.get('color')};
    }
`;
